"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../utils");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const Container = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "SpinnerContent__Container",
  componentId: "components-web__sc-1c8bd8e-0"
})(_ref => {
  let {
    overlay
  } = _ref;
  return {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...(overlay && {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: _constants.BACKDROP_Z_INDEX
    })
  };
});
const SpinnerContent = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    label,
    labelPosition,
    overlay = false,
    sizeVariant,
    size,
    thickness,
    isStatic,
    showLabel = sizeVariant === _constants.LARGE,
    ...rest
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Container, {
    overlay: overlay,
    ref: ref,
    "aria-label": label,
    role: "status",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.ActivityIndicator, {
      role: "progressbar",
      "aria-busy": "true",
      "aria-valuetext": label,
      label: label,
      labelPosition: labelPosition,
      showLabel: showLabel,
      tokens: {
        size,
        thickness
      },
      isStatic: isStatic,
      ...selectProps(rest)
    })
  });
});
SpinnerContent.displayName = 'SpinnerContent';
SpinnerContent.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Communicates a message to assistive technology while visible. This same message will appear underneath the spinner when its `size` is `large`.
   */
  label: _propTypes.default.string.isRequired,
  /**
   * Whether the container has to have an overlay styling.
   */
  overlay: _propTypes.default.bool,
  /**
   * Size (width and height) of the spinner.
   */
  size: _propTypes.default.number,
  /**
   * The size of the spinner
   */
  sizeVariant: _propTypes.default.oneOf(['large', 'small']),
  /**
   * If true, it should render a static spinner
   */
  isStatic: _propTypes.default.bool
};
var _default = exports.default = SpinnerContent;